export function formatString(input) {
    // Replace underscores with spaces and capitalize the first letter of each word
    return input
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }